import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { TagEvent } from 'tag/ts/tag/events/TagEvent';
import { TagLoggerString } from 'tag/ts/tag/model/enums/TagLoggerString';
import { AdSetupDefinition } from 'tag/ts/tag/model/type/ads/AdSetupDefinition';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
import { AviaPlayerDaiApiAdHook } from 'tag/ts/tag/player/adapters/avia/hooks/AviaPlayerDaiApiAdHook';
import { AviaPlayerInjectedAdHook } from 'tag/ts/tag/player/adapters/avia/hooks/AviaPlayerInjectedAdHook';
import { AviaPlayerPreferredVideoCodecHook } from 'tag/ts/tag/player/adapters/avia/hooks/AviaPlayerPreferredVideoCodecHook';
import { AviaPlayerPremiumAudioHook } from 'tag/ts/tag/player/adapters/avia/hooks/AviaPlayerPremiumAudioHook';
export class AviaPlayerHooksManager extends AbstractTagClass {
    #adaptedPlayerInstance;
    #activePlayerHooks = [];
    constructor(argument) {
        super({
            ...argument,
            name: 'AviaPlayerHooksManager'
        });
        this.#adaptedPlayerInstance = argument?.player;
        this.tagEventsHandler(this.#onTagEvent, [
            TagEvent.ON_PLAYER_HOOK_REQUEST_REGISTER,
            TagEvent.ON_PLAYER_HOOK_REQUEST_REMOVE
        ]);
        this.#initAdHook();
        if (this?.tag?.model?.config?.tag?.Hooks?.params?.PreferredVideoCodecHook?.enabled === true && this?.tag?.params?.SYSTEM?.embedType === EmbedType.HTML5) {
            new AviaPlayerPreferredVideoCodecHook({ tag: argument?.tag });
        }
        this?.logger?.log('[PLSTVVID-3370 debug] tag config:', this?.tag?.model?.config?.tag);
        if (this?.tag?.model?.config?.tag?.Hooks?.params?.PremiumAudioHook?.enabled === true) {
            this?.logger?.log('[PLSTVVID-3370 debug] Premium Audio Hook is enabled in TAG config');
            const preferredAudioCodecs = argument.tag?.params?.CONTENT?.resource?.playback?.preferredAudioCodecs || [];
            if (this.utils.Type.isArray(preferredAudioCodecs) && !this.utils.Type.isEmpty(preferredAudioCodecs)) {
                this?.logger?.log('[PLSTVVID-2137 debug] User has audio preference, add hook');
                new AviaPlayerPremiumAudioHook({ tag: argument?.tag });
            }
            else {
                this?.logger?.log('[PLSTVVID-2137 debug] User has no audio preference, not adding hook');
            }
        }
        else {
            this?.logger?.log('[PLSTVVID-3370 debug] Premium Audio Hook not enabled in feature flags');
        }
    }
    #initAdHook = () => {
        const adSetupInfo = this.tag.model.adUtilities.adSetupInfo();
        this?.logger?.log('initAdHook', 'adSetupInfo:', adSetupInfo);
        if (!this.utils.Type.isEmpty(this?.callbacks?.isSkippable)) {
            new AviaPlayerInjectedAdHook({ tag: this.tag, isSkippableCallback: this?.callbacks?.isSkippable });
            return;
        }
        if (adSetupInfo?.setup?.definition === AdSetupDefinition.DAI_API) {
            new AviaPlayerDaiApiAdHook({ tag: this.tag });
            return;
        }
    };
    #onTagEvent = (event) => {
        switch (event?.type) {
            case TagEvent.ON_PLAYER_HOOK_REQUEST_REGISTER:
                this?.logger?.log(this.name, TagLoggerString.ON_TAG_EVENT, event?.type, event);
                this.addHook(event?.data?.playerHookRequestRegister?.hook);
                break;
            case TagEvent.ON_PLAYER_HOOK_REQUEST_REMOVE:
                this.removeHook(event?.data?.playerHookRequestRemove?.hook);
                break;
        }
    };
    addHook = (hook) => {
        if (this.utils.Type.isEmpty(hook)) {
            this?.logger?.warn('addHook', 'missing/invalid params', 'hook:', hook);
            return;
        }
        this?.logger?.log('registering hook with avia player', '\ntype:', hook.hookType, '\nhook:', hook, '\nplayer:', this.#adaptedPlayerInstance);
        this.#adaptedPlayerInstance.registerHook(hook.hookType, hook.callback);
        this.#activePlayerHooks.push(hook);
        this.dispatchTagEvent(this.getTagEventVO(TagEvent.ON_PLAYER_HOOK_REGISTERED, this.tag, {
            player: this?.tag?.controller?.playerManager?.player,
            adaptedPlayerInstance: this.#adaptedPlayerInstance,
            hook: hook
        }, this));
    };
    removeHook = (hook) => {
        if (this.utils.Type.isEmpty(hook)) {
            this?.logger?.warn('removeHook', 'missing/invalid params', 'hook:', hook);
            return;
        }
        const index = this.#activePlayerHooks.indexOf(hook);
        if (index < 0) {
            this?.logger?.warn('removeHook', 'hook not found:', hook);
            return;
        }
        this?.logger?.log('removing hook from avia player', '\ntype:', hook.hookType, '\nhook:', hook, '\nplayer:', this.#adaptedPlayerInstance);
        this.#adaptedPlayerInstance.removeHook(hook.hookType, hook.callback);
        this.#activePlayerHooks.splice(index, 1);
        this.dispatchTagEvent(this.getTagEventVO(TagEvent.ON_PLAYER_HOOK_REMOVED, this.tag, {
            player: this?.tag?.controller?.playerManager?.player,
            adaptedPlayerInstance: this.#adaptedPlayerInstance,
            hook: hook
        }, this));
    };
    cleanUp = () => {
        return new Promise((resolve, reject) => {
            this.#activePlayerHooks.filter((hook) => !this.utils.Type.isEmpty(hook?.cleanUp)).forEach((hook) => {
                hook.cleanUp();
                hook = undefined;
            });
            this.removeTagEventsHandler(this.#onTagEvent, this.tag.eventDispatcher, [
                TagEvent.ON_PLAYER_HOOK_REQUEST_REGISTER,
                TagEvent.ON_PLAYER_HOOK_REQUEST_REMOVE
            ]).then((data) => {
                resolve({ msg: `${this.name}: cleanUp is done!`, success: true });
            });
        });
    };
}
